import React, { useEffect, useRef, useState } from 'react'
import { ApiService, ModalForAll, returnFullURL } from "../../components";
import { toast } from 'react-toastify';
import Select from "react-select";
import AddIconMI from "@mui/icons-material/AddCircleOutlineRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { TextField } from '@mui/material';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ModalNuevaCategoria } from './ModalNuevaCategoria';
import { ModalNuevaMarca } from './ModalNuevaMarca';
import ModalNuevoProveedor from './ModalNuevoProveedor';
import UploadIcon from '@mui/icons-material/Upload';
import { convertString, returnCurrentDate } from '../../utils/goblaFunctions';

const customStyles = {
    container: (provided) => ({
        ...provided,
        width: '100%',
    }),
    control: (provided) => ({ //no se usa
        ...provided,
        width: '100%',
        height: '20px !important',
    }),
    valueContainer: (provided) => ({
        ...provided,
        color: '#000',
        textAlign: 'left',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000',
    }),
    input: (provided) => ({
        ...provided,
        color: '#000',
        textAlign: 'left',
        fontSize: '14px',
    }),
    option: (provided, state) => ({
        ...provided,
        color: '#000', // color del texto
        backgroundColor: state.isFocused ? '#f0f0f0' : 'white', // opcional: resaltar al pasar mouse
        textAlign: 'left',
        fontSize: '14px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#000',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // para evitar que quede oculto si hay overflow
    }),
};

export function ProductModal({
    stateModal = false,
    copiedObject = {},
    productSelected = {},
    reload = (() => { }),
    dataModal = {},
    current_branch = "authCode_Here",
    onClose = (() => { }),
    theme = "#989d96",
    modal_type = "add",
    updateProduct = (() => { })
}) {
    // console.log("Datos modal:", dataModal);
    // console.log("Datos producto:", productSelected);
    const findData = (field, value) => {
        if (value == "") return "";

        const arrayConverted = Array.from(dataModal[field] ?? []);

        if (field != "city") {
            const buscar = arrayConverted.find((data) => data?.name == value);
            return { value: buscar["key_" + field] ?? 0, label: buscar?.name };
        }

        if (field == "city") {
            const findCity = arrayConverted.find((data) => data == value);
            return { value: findCity, label: findCity };
        }
    }

    const urlSelected = (modal_type == "add" ? "api/company/product/insert?key_branch=" : "api/company/product/update?key_branch=") + current_branch;
    //CAMPOS DE PRODUCTO
    const [stateName, setStateName] = useState("");
    const [stateCode, setStateCode] = useState("");
    const [statePrice, setStatePrice] = useState("");
    const [statePrice2, setStatePrice2] = useState("");
    const [statePrice3, setStatePrice3] = useState("");
    const [statePurchase, setStatePurchase] = useState("");
    const [stateImages, setStateImages] = useState([]);
    const [stateStock, setStateStock] = useState("");
    const [stateSupplier, setStateSupplier] = useState("");
    const [stateDescription, setStateDescription] = useState({});
    const [stateLocality, setStateLocality] = useState("");
    const [stateBrand, setStateBrand] = useState("");
    const [stateWholesale, setStateWholesale] = useState("");
    const [stateCategory, setStateCategory] = useState("");
    //FIN CAMPOS DE PRODUCTO
    const [objectDetailValue, setObjectDetailValue] = useState({
        title: "",
        text: "",
    });
    const [miniModalState, setMiniModalState] = useState(false);

    const [stateModales, setStateModales] = useState({
        category: false,
        brand: false,
        supplier: false,
    });

    const [tempImg, setTempImg] = useState([]);
    const [stateUpsert, setStateUpsert] = useState(false);
    const refModaDetail = useRef(null);
    const focusTitle = useRef(null);
    const tempImgRef = useRef(tempImg);

    useEffect(() => {
        tempImgRef.current = tempImg;
    }, [tempImg]);

    function handleModalState(modal_name = null) {
        if (!modal_name) return;
        setStateModales((old_data) => ({
            ...old_data,
            [modal_name]: !old_data[modal_name]
        }));
    }

    const contentSelect = (field, title, placeholder, tabPosition) => {
        const valores = {
            city: stateLocality,
            brand: stateBrand,
            category: stateCategory,
            supplier: stateSupplier,
        };

        const newList = (dataModal[field] ?? []).map((items) => ({ value: (field != "city" ? items["key_" + field] : items), label: (field != "city" ? items.name : items) }));
        return (
            <div>
                <label className='normal-black text-bold' htmlFor={field + "Product"}>{title}</label>

                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Select
                        name={field + "Product"}
                        options={newList}
                        value={valores[field]}
                        onChange={(event) => setValueSelects(event, field)}
                        placeholder={placeholder}
                        styles={customStyles}
                        tabIndex={tabPosition}
                        isDisabled={modal_type === "edit" && field === "brand"}
                        isClearable
                    />
                    {
                        field != "city" && (
                            <button className='default-buttons' onClick={(event) => { event.preventDefault(); handleModalState(field); }}>
                                <AddIconMI style={{ color: '#2E7D32' }} />
                            </button>
                        )
                    }

                </div>
            </div>
        )
    }

    const FieldValues = (text, min, max) => ({
        text: text,
        min: min,
        max: max
    });

    const fieldsRules = {
        code: FieldValues('Codigo', 2, 20),
        name: FieldValues('Nombre', 4, 100),
        purchase: FieldValues('Precio de compra', 0.01, 999999.99),
        price1: FieldValues('Precio de Venta1', 0.01, 999999.99),
        price2: FieldValues('Precio de Venta2', 0.01, 999999.99),
        price3: FieldValues('Precio de Venta3', 0.01, 999999.99),
        wholesale: FieldValues('Precio de mayorista', 0.01, 999999.99),
        stock: FieldValues('Stock', 0, 99999),
    };

    const setValueInputs = (field, type, value) => {
        if (!fieldsRules[field]) return toast.error(`El campo ${field} no existe`, { autoClose: 1000 });
        const { text, min, max } = fieldsRules[field];
        // if ((type == 'text' && String(value).length < min) || (type == 'number' && value < min)) toast.warning(`${text} ${type == 'text' ? `${min} letras minimo` : `valor minimo ${min}`}`, { autoClose: 1500 });
        if ((type == 'text' && String(value).length > max) || (type == 'number' && value > max)) return toast.warning(`${text} ${type == 'text' ? `${max} letras maxima` : `valor maximo ${max}`}`, { autoClose: 1500 });

        switch (field) {
            case "code":
                setStateCode(value);
                break;
            case "name":
                setStateName(value);
                break;
            case "purchase":
                setStatePurchase(value);
                break;
            case "price1":
                setStatePrice(value);
                break;
            case "price2":
                setStatePrice2(value);
                break;
            case "price3":
                setStatePrice3(value);
                break;
            case "wholesale":
                setStateWholesale(value);
                break;
            case "stock":
                setStateStock(value);
                break;
            default:
                toast.info("Valor del campo ingresado no existe");
                break;
        }
    }

    const setValueSelects = (value, field) => {
        if (field == "city") setStateLocality(value);
        if (field == "brand") setStateBrand(value);
        if (field == "category") setStateCategory(value);
        if (field == "supplier") setStateSupplier(value);
    }

    function showModalDetail(event) {
        event?.stopPropagation();
        if (focusTitle.current && miniModalState == false) {
            setMiniModalState(true);
            focusTitle.current.focus();
        }
    }

    function setDetails(event) {
        if (event != null && event.key == 'Escape') return setMiniModalState(false);
        if (event != null && event.key != 'Enter') return;
        if (!objectDetailValue.title || !objectDetailValue.text) return;

        setStateDescription((current_value) => ({
            ...current_value,
            [objectDetailValue.title]: objectDetailValue.text
        }));

        setObjectDetailValue({
            title: "",
            text: "",
        });

        focusTitle.current.focus();
    }

    function editDetail(campo, valor) {
        setObjectDetailValue({
            title: campo,
            text: valor,
        });

        showModalDetail();
    }

    const deleteDetail = (event, position = 0) => {
        event.preventDefault();
        const object_descripcion = stateDescription ?? {};
        const keyRemove = Object.keys(object_descripcion)[position];

        if (keyRemove !== undefined) {
            // Crear un nuevo objeto excluyendo la clave que se quiere eliminar
            const newObject = Object.fromEntries(
                Object.entries(object_descripcion).filter(([key]) => key !== keyRemove)
            );

            setStateDescription(newObject);
        }
    }

    const onDragEnd = (result) => {
        const { source, destination } = result;

        if (!destination) return; // sucede cuando suelta el elemento fuera
        if (source.index === destination.index) return; // Esto sucede cuando no se movio el elemento

        setStateImages((old_data) => {
            const updatedList = Array.from(old_data ?? []);
            const [movedItem] = updatedList.splice(source.index, 1);
            updatedList.splice(destination.index, 0, movedItem);
            return updatedList;
        });
    };

    const addImage = (event) => {
        event.preventDefault();
        const listFiles = Array.from(event.target.files ?? []);

        let contador = stateImages?.length ?? 0;
        const newFiles = [];

        for (let index = 0; index < listFiles.length; index++) {
            const file = listFiles[index];
            const extension = file.name.split(".").pop()?.toLowerCase();

            const isValidMime = ["image/png", "image/jpg", "image/jpeg"].includes(file?.type);
            const isValidExtension = ["png", "jpg", "jpeg"].includes(extension);

            if (isValidMime && isValidExtension) contador++;
            else continue;

            if (contador > 5) break;

            const urlTempImg = URL.createObjectURL(file);

            setTempImg((current_data) => [...current_data, urlTempImg]);

            if (file) {
                newFiles.push({
                    file: file,
                    temporalImg: urlTempImg
                }); // Guardamos el archivo como File (binario)
            }
        }

        // Agrega los nuevos archivos a los ya existentes (si hay menos de 5)
        setStateImages((old_data) => {
            const currentFiles = old_data ?? [];
            const totalFiles = currentFiles.concat(newFiles).slice(0, 5);
            return totalFiles;
        });
    };

    function removeImg(event, position) {
        event.preventDefault();
        setStateImages((old_data) => Array.from(old_data ?? []).filter((url, index) => index != position));
    }

    const validationFields = (field, verify, type, value) => {
        const current_var = fieldsRules[field];
        const fields_text = {
            category: "Selecciona una categoria",
            brand: "Selecciona una marca",
            ciudad: "Selecciona una ciudad",
            suplier: "Selecciona una proveedor",
        };

        if ((type != "select" && !current_var) || (type == "select" && !fields_text[field])) {
            toast.warning(`Campo ${field} no existe`);
            return true;
        }

        if (type == "number") {
            if (value < current_var.min && verify == "all") {
                toast.warning(`${current_var.text} valor minimo ${current_var.min}`);
                return true;
            }
            if (value > current_var.max) {
                toast.warning(`${current_var.text} valor maximo ${current_var.max}`);
                return true;
            }
        }
        if (type == "select") {
            if (!value?.label) {
                toast.warning(fields_text[field]);
                return true;
            }
        }

        if (type == "text") {
            if (convertString(value).length < current_var.min && verify == "all") {
                toast.warning(`${current_var.text} letras minimo ${current_var.min}`);
                return true;
            }
            if (convertString(value).length > current_var.max) {
                toast.warning(`${current_var.text} limite de letras ${current_var.max}`);
                return true;
            }
        }

        return false;
    }

    async function actionModal() {
        // console.log("Localidad",stateLocality);
        // console.log("Categoria",stateCategory);
        // console.log("Proveedor",stateSupplier);
        // console.log("Marca",stateBrand);
        // return;
        const list_images = stateImages;
        setStateUpsert(true);

        if (
            validationFields("code", "all", "text", stateCode) ||
            validationFields("name", "all", "text", stateName) ||
            validationFields("stock", "all", "number", stateStock) ||
            validationFields("purchase", "all", "number", statePurchase) ||
            validationFields("price1", "all", "number", statePrice) ||
            validationFields("price2", "all", "number", statePrice2) ||
            validationFields("price3", "all", "number", statePrice3) ||
            validationFields("wholesale", "all", "number", stateWholesale) ||

            validationFields("ciudad", "all", "select", stateLocality) ||
            validationFields("category", "all", "select", stateCategory) ||
            validationFields("suplier", "all", "select", stateSupplier) ||
            validationFields("brand", "all", "select", stateBrand)
        ) {
            setStateUpsert(false);
            return;
        }

        if (Object.keys(stateDescription).length <= 0) {
            toast.warning("Es necesario al menos un detalle");
            setStateUpsert(false);
            return;
        }

        if ((list_images ?? []).length <= 0) {
            toast.warning("Es necesario al menos una imagen");
            setStateUpsert(false);
            return;
        }
        var newList = [];;
        let uploadImageState = false;

        for (const image of list_images) {
            if (image?.temporalImg == null) {
                newList.push(image);
                continue;
            }

            if (!uploadImageState) uploadImageState = true;
            const convert_image = new FormData();
            convert_image.append("file", image.file);

            const upload_img = await ApiService.fetchData(
                "api/upload/file",
                {
                    method: "POST",
                    body: convert_image,
                },
                false
            );
            newList.push(upload_img?.url ?? null);
        }

        const old_imgs = Array.from(productSelected?.images ?? []);
        uploadImageState = old_imgs.length != newList.length;

        if (!uploadImageState) {
            for (let i = 0; i < old_imgs.length; i++) {
                const img = old_imgs[i];

                if (img != newList[i]) {
                    uploadImageState = true;
                    break;
                }
            }
        }
        const objectRequest = {};

        if (productSelected?.key_product && modal_type == "edit") objectRequest.key_product = productSelected?.key_product ?? null;
        if (productSelected?.code != stateCode && modal_type == "add") objectRequest.code = stateCode;
        if (productSelected?.name != stateName) objectRequest.nameProduc = stateName;
        if (productSelected?.stock != stateStock) objectRequest.stock = stateStock;
        if (productSelected?.price != statePrice) objectRequest.price1 = parseFloat(statePrice).toFixed(2);
        if (productSelected?.price2 != statePrice2) objectRequest.price2 = parseFloat(statePrice2).toFixed(2);
        if (productSelected?.price3 != statePrice3) objectRequest.price3 = parseFloat(statePrice3).toFixed(2);
        if (productSelected?.wholesale != stateWholesale) objectRequest.wholesale = parseFloat(stateWholesale).toFixed(2);
        if (productSelected?.purchase_price != statePurchase) objectRequest.purchase = parseFloat(statePurchase).toFixed(2);
        if (productSelected?.category != stateCategory.label) objectRequest.categoria = stateCategory.value;
        if (productSelected?.brand != stateBrand.label) objectRequest.marca = stateBrand.value;
        if (productSelected?.supplier != stateSupplier.label) objectRequest.supplier = stateSupplier.value;
        if (productSelected?.locality != stateLocality.label) objectRequest.locality = stateLocality.value;
        if (uploadImageState) objectRequest.arrayImg = newList;
        if (productSelected?.description != stateDescription) objectRequest.detail = stateDescription;

        const countkeys = Object.keys(objectRequest).length;
        if ((modal_type == "edit" && countkeys <= 1) || (modal_type == "add" && countkeys <= 1)) {
            toast.info("No se detectaron cambios para guardar");
            setStateUpsert(false);
            return;
        }

        const upsert_obj = await ApiService.fetchData(urlSelected, {
            method: modal_type == "add" ? 'POST' : 'PUT',
            body: JSON.stringify(objectRequest),
        });

        if (upsert_obj?.code == 200) {
            const productUpdated = modal_type == "edit" && {
                brand: stateBrand.label,
                category: stateCategory.label,
                code: stateCode,
                description: stateDescription,
                images: upsert_obj?.result?.array_img ?? [],
                key_product: productSelected?.key_product,
                last_update: returnCurrentDate(true),
                locality: stateLocality.label,
                name: stateName,
                price: parseFloat(statePrice).toFixed(2),
                price2: parseFloat(statePrice2).toFixed(2),
                price3: parseFloat(statePrice3).toFixed(2),
                purchase_price: parseFloat(statePurchase).toFixed(2),
                selected: productSelected?.selected ? true : false,
                stock: stateStock,
                supplier: stateSupplier.label,
                supplierFullname: upsert_obj?.result?.supplier_name ?? "No obtenido",
                wholesale: parseFloat(stateWholesale).toFixed(2)
            };
            updateProduct(modal_type, productUpdated ? productUpdated : upsert_obj?.result);
        }
        setStateUpsert(false);
    }

    function dropImages(event) {
        event.preventDefault();
        const listFiles = Array.from(event.dataTransfer.files ?? []);

        let contador = stateImages?.length ?? 0;
        const newFiles = [];

        for (let index = 0; index < listFiles.length; index++) {
            const file = listFiles[index];
            const extension = file.name.split(".").pop()?.toLowerCase();

            const isValidMime = ["image/png", "image/jpg", "image/jpeg"].includes(file?.type);
            const isValidExtension = ["png", "jpg", "jpeg"].includes(extension);

            if (isValidMime && isValidExtension) contador++;
            else continue;

            if (contador > 5) break;

            const urlTempImg = URL.createObjectURL(file);

            setTempImg((current_data) => [...current_data, urlTempImg]);

            if (file) {
                newFiles.push({
                    file: file,
                    temporalImg: urlTempImg
                }); // Guardamos el archivo como File (binario)
            }
        }

        // Agrega los nuevos archivos a los ya existentes (si hay menos de 5)
        setStateImages((old_data) => {
            const currentFiles = old_data ?? [];
            const totalFiles = currentFiles.concat(newFiles).slice(0, 5);

            setDragState(false)
            return totalFiles;
        });
    }

    function pasteObject(evento) {
        evento.stopPropagation();
        const getObject = copiedObject;

        if (modal_type == "add") {
            setStateCode(getObject?.code ?? "");
            setStateBrand(findData("brand", getObject?.brand ?? ""));
        }

        setStateName(getObject?.name ?? "");
        setStatePrice(getObject?.price ?? "");
        setStatePrice2(getObject?.price2 ?? "");
        setStatePrice3(getObject?.price3 ?? "");
        setStatePurchase(getObject?.purchase_price ?? "");
        setStateWholesale(getObject?.wholesale ?? "");
        // setStateImages(getObject?.images ?? ""); Temporalmente deshabilitado porque da error al subir
        setStateStock(getObject?.stock ?? "");
        setStateDescription(getObject?.description ?? "");

        setStateSupplier(findData("supplier", getObject?.supplier ?? ""));
        setStateLocality(findData("city", getObject?.locality ?? ""));
        setStateCategory(findData("category", getObject?.category ?? ""));
    }

    const [dragState, setDragState] = useState(false);

    useEffect(() => {
        function manejarClickFuera(event) {
            if (refModaDetail.current && !refModaDetail.current.contains(event.target)) {
                setMiniModalState(false);
            }
        }
        document.addEventListener('mousedown', manejarClickFuera);

        return () => {
            Array.from(tempImgRef.current ?? []).forEach((urls) => URL.revokeObjectURL(urls));

            document.removeEventListener('mousedown', manejarClickFuera);
        };
    }, []);

    useEffect(() => {
        setStateName(productSelected?.name ?? "");
        setStateCode(productSelected?.code ?? "");
        setStatePrice(productSelected?.price ?? "");
        setStatePrice2(productSelected?.price2 ?? "");
        setStatePrice3(productSelected?.price3 ?? "");
        setStatePurchase(productSelected?.purchase_price ?? "");
        setStateImages(productSelected?.images ?? []);
        setStateStock(productSelected?.stock ?? "");
        setStateSupplier(findData("supplier", productSelected?.supplier ?? ""));
        setStateDescription(productSelected?.description ?? {});
        setStateLocality(findData("city", productSelected?.locality ?? ""));
        setStateBrand(findData("brand", productSelected?.brand ?? ""));
        setStateWholesale(productSelected?.wholesale ?? "");
        setStateCategory(findData("category", productSelected?.category ?? ""));
    }, [productSelected]);
    return (
        <ModalForAll className='modal-product' stateModal={stateModal} setStateModal={onClose}>
            <h3 className='font-h2' style={{ color: theme, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <span></span>
                {modal_type == "add" ? "Agregar " : "Editar "}
                Producto
                {Object.keys(copiedObject).length > 0 ?
                    (<button
                        className='default-buttons'
                        style={{ color: '#fff', fontSize: '15px', backgroundColor: theme, padding: '8px', borderRadius: '10px', marginRight: '12px' }}
                        onClick={(event) => pasteObject(event)}
                    >
                        <ContentPasteIcon fontSize='small' />&nbsp;Pegar
                    </button>)
                    : (<span></span>)
                }
            </h3>

            <div className='body-product-form'>
                <div className='content-inputs-bpf'>
                    <div>
                        <label className='normal-black text-bold' htmlFor={"codeProduct"}>Código</label>
                        <input
                            type="text"
                            name="codeProduct"
                            value={stateCode ?? ""}
                            placeholder={"EAN-13"}
                            onChange={(event) => setValueInputs("code", "text", event.target.value)}
                            tabIndex={1}
                            disabled={modal_type === "edit"}
                        />
                    </div>

                    <div>
                        <label className='normal-black text-bold' htmlFor={"nameProduct"}>Nombre del producto</label>
                        <input
                            type="text"
                            name="nameProduct"
                            value={stateName ?? ""}
                            placeholder={"Motor de agua..."}
                            onChange={(event) => setValueInputs("name", "text", event.target.value)}
                            tabIndex={2}
                        />
                    </div>
                    {contentSelect("city", "Ciudad", "Selecciona una ciudad", 3)}

                    <div>
                        <label className='normal-black text-bold' htmlFor={"purchaseProduct"}>Precio de compra</label>
                        <input
                            type="number"
                            onBlur={(item) => setStatePurchase(String(item.target.value).replace(/[eE\+\-]/g, ''))}
                            name="purchaseProduct"
                            step={0.01}
                            value={statePurchase ?? "0.00"}
                            placeholder={"0.00"}
                            onChange={(event) => setValueInputs("purchase", "number", event.target.value)}
                            tabIndex={4}
                        />
                    </div>

                    <div>
                        <label className='normal-black text-bold' htmlFor={"price1Product"}>Precio de venta 1</label>
                        <input
                            type="number"
                            onBlur={(item) => setStatePrice(String(item.target.value).replace(/[eE\+\-]/g, ''))}
                            name="price1Product"
                            step={0.01}
                            value={statePrice ?? "0.00"}
                            placeholder={"0.00"}
                            onChange={(event) => setValueInputs("price1", "number", event.target.value)}
                            tabIndex={5}
                        />
                    </div>

                    <div>
                        <label className='normal-black text-bold' htmlFor={"price2Product"}>Precio de venta 2</label>
                        <input
                            type="number"
                            onBlur={(item) => setStatePrice2(String(item.target.value).replace(/[eE\+\-]/g, ''))}
                            name="price2Product"
                            step={0.01}
                            value={statePrice2 ?? "0.00"}
                            placeholder={"0.00"}
                            onChange={(event) => setValueInputs("price2", "number", event.target.value)}
                            tabIndex={6}
                        />
                    </div>

                    <div>
                        <label className='normal-black text-bold' htmlFor={"price3Product"}>Precio de venta 3</label>
                        <input
                            type="number"
                            onBlur={(item) => setStatePrice3(String(item.target.value).replace(/[eE\+\-]/g, ''))}
                            name="price3Product"
                            step={0.01}
                            value={statePrice3 ?? "0.00"}
                            placeholder={"0.00"}
                            onChange={(event) => setValueInputs("price3", "number", event.target.value)}
                            tabIndex={7}
                        />
                    </div>

                    <div>
                        <label className='normal-black text-bold' htmlFor={"wholesaleProduct"}>Precio por mayor</label>
                        <input
                            type="number"
                            onBlur={(item) => setStateWholesale(String(item.target.value).replace(/[eE\+\-]/g, ''))}
                            name="wholesaleProduct"
                            step={0.01}
                            value={stateWholesale ?? "0.00"}
                            placeholder={"0.00"}
                            onChange={(event) => setValueInputs("wholesale", "number", event.target.value)}
                            tabIndex={8}
                        />
                    </div>
                    {contentSelect("category", "Categoría", "Selecciona una categoría", 9)}

                    <div>
                        <label className='normal-black text-bold' htmlFor={"stockProduct"}>Stock</label>
                        <input
                            type="number"
                            name="stockProduct"
                            step={1}
                            value={stateStock ?? "0.00"}
                            placeholder={"0.00"}
                            onChange={(event) => setValueInputs("stock", "number", event.target.value)}
                            tabIndex={10}
                        />
                    </div>
                    {contentSelect("supplier", "Proveedor", "Selecciona un proveedor", 11)}
                    {contentSelect("brand", "Marca", "Selecciona una marca", 12)}
                </div>

                <div>
                    <label className='label-form' style={{ display: 'flex', gap: '5px', position: 'relative', width: 'fit-content' }}>
                        Detalles (1 a 15 máximo)
                        {/* showModalDetailevent */}
                        <button className='default-buttons' onClick={showModalDetail}>
                            <AddIconMI style={{ color: '#2E7D32' }} />
                        </button>

                        <div ref={refModaDetail} className={`shadow-lvl6 mini-modal-detail ${miniModalState ? 'mmd-active' : 'mmd-hide'}`}>
                            <TextField
                                label="Título"
                                value={objectDetailValue.title}
                                onChange={(item) => setObjectDetailValue((current_value) => ({ ...current_value, title: item.target.value }))}
                                onKeyDown={(event) => setDetails(event)}
                                fullWidth
                                autoComplete='off'
                                autoFocus
                                inputRef={focusTitle}
                            />

                            <TextField
                                label="Descripcion"
                                value={objectDetailValue.text}
                                onChange={(item) => setObjectDetailValue((current_value) => ({ ...current_value, text: item.target.value }))}
                                onKeyDown={(event) => setDetails(event)}
                                fullWidth
                                autoComplete='off'
                            />

                            <button className='default-buttons form-buttons' type="submit" onClick={(event) => { event.stopPropagation(); event.preventDefault(); setDetails(null); }} style={{ backgroundColor: '#3F77F3' }}>AGREGAR</button>
                        </div>
                    </label>

                    <ul className='content-inputs-bpf list-descriptions-product'>
                        {
                            Object.entries((stateDescription && stateDescription) ?? {}).map((field_value, index) => (
                                <li onClick={() => editDetail(field_value[0], field_value[1])} style={{ cursor: 'pointer', padding: '8px', borderRadius: '10px', backgroundColor: 'var(--theme-main)' }}>
                                    <span><b>{field_value[0]}:</b>&nbsp;{field_value[1]}</span>

                                    <button className='default-buttons' onClick={(event) => { event.stopPropagation(); deleteDetail(event, index); }}>
                                        <DeleteIcon />
                                    </button>
                                </li>
                            ))
                        }

                    </ul>
                </div>

                <div className='container-control-images'>
                    <label className='label-form'>Imagenes (1 a 5 máximo)</label>

                    <div className='control-images'>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId={"authCode"} key={"authCode"} direction="horizontal">
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        style={{
                                            display: 'flex',
                                            gap: '10px',
                                        }}
                                    >
                                        {stateImages && (stateImages ?? []).map((item, index) => (
                                            <Draggable draggableId={"drag_" + index} index={index} key={index}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            borderRadius: '15px',
                                                            overflow: 'hidden',
                                                            boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                                                            position: 'relative',
                                                            ...provided.draggableProps.style
                                                        }}
                                                    >
                                                        <img src={item?.temporalImg ? item.temporalImg : returnFullURL(item, "picture")} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} />
                                                        <button className='default-buttons' style={{ position: 'absolute', height: 'min-content', top: '5px', right: '5px' }} onClick={(event) => removeImg(event, index)}>
                                                            <CancelIcon sx={{ color: '#FF0000', fontSize: '25px' }} />
                                                        </button>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                        {
                            (stateImages ?? []).length < 5 && (
                                <div
                                    className={'add-product-image' + (dragState ? ' drag-active' : '')}
                                    drag-active
                                    onDrop={dropImages}
                                    onDragOver={() => { if (!dragState) setDragState(true); }}
                                    onDragLeave={() => setDragState(false)}
                                >
                                    <span className='span-inactive'>Arrastra tu archivo aqui...</span>
                                    <input type='file' title='Agregar Producto' onChange={addImage} accept='.jpg, .jpeg, .png' multiple />
                                    {!dragState && (<AddIcon sx={{ color: '#D8D6D9', fontSize: '60px' }} />)}
                                    {dragState && (<UploadIcon sx={{ color: '#D8D6D9', fontSize: '60px' }} />)}
                                </div>
                            )
                        }
                    </div>
                </div>


                <div className='content-buttons'>
                    <button className='default-buttons form-buttons' style={{ backgroundColor: '#E62E2D' }} onClick={(event) => { event.preventDefault(); onClose(false); }}>
                        Cancelar
                    </button>

                    <input type='button' className='default-buttons form-buttons' style={{ backgroundColor: '#3F77F3' }} value={stateUpsert ? (modal_type == "edit" ? "Actualizando..." : "Guardando...") : "Guardar"} onClick={() => actionModal()} disabled={stateUpsert} />
                </div>
            </div>

            {
                stateModales.category && (<ModalNuevaCategoria
                    onClose={() => handleModalState("category")}
                    onCategoryAdded={reload}
                    selectedSucursal={current_branch}
                />)
            }

            {
                stateModales.brand && (<ModalNuevaMarca
                    onClose={() => handleModalState("brand")}
                    onBrandAdded={reload}
                    selectedSucursal={current_branch}
                />)
            }

            {
                stateModales.supplier && (<ModalNuevoProveedor
                    onClose={() => handleModalState("supplier")}
                    onSave={reload}
                    list_city={Array.from(dataModal?.city ?? []).map((data) => ({ label: data, value: data }))}
                    selectedSucursal={current_branch}
                />)
            }
        </ModalForAll>
    )
}
